import { create } from "zustand";

type ReportStateByChat = Record<string, { selectedReportIndex: number }>;

interface ReportState {
  reportStateByChat: ReportStateByChat;
  getSelectedReportIndex: (chatId: string) => number;
  setSelectedReportIndex: (chatId: string, index: number) => void;
  clearAll: () => void;
}

export const useReportStore = create<ReportState>((set, get) => ({
  reportStateByChat: {},

  getSelectedReportIndex: (chatId: string) =>
    get().reportStateByChat[chatId]?.selectedReportIndex ?? 0,

  setSelectedReportIndex: (chatId: string, index: number) => {
    set((state) => ({
      reportStateByChat: {
        ...state.reportStateByChat,
        [chatId]: {
          selectedReportIndex: index,
        },
      },
    }));
  },

  clearAll: () => set({ reportStateByChat: {} }),
}));
